import "./ChiropractorInLimassol.module.css";
import Header from "@/reusable_sections/Header";
import ServicesOverview from "./sections/ServicesOverview";
import VisitUs from "./sections/VisitUs";
import ServicesPreview from "./sections/ServicesPreview";
import LocalAreaContent from "./sections/LocalAreaContent";
import TestimonialsFromLimassolPatients from "./sections/TestimonialsFromLimassolPatients";
import Faq from "./sections/Faq";
import BookAnAppointment from "./sections/BookAnAppointment";
import Footer from "@/reusable_sections/Footer";
export default function ChiropractorInLimassolPage() {
  return <div>
      <Header />
      <ServicesOverview />
      <VisitUs />
      <ServicesPreview />
      <LocalAreaContent />
      <TestimonialsFromLimassolPatients />
      <Faq />
      <BookAnAppointment />
      <Footer />
    </div>;
}